import React, { useState } from "react";
import {
  TextInput,
  useRecordContext,
  useResourceContext,
  required,
} from "react-admin";
import { DialogueContext } from "../../../Components/ActionsMenu";
import { EditForm } from "../../../Layout/EditForm";
import { Dialog, Grid, IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

export const ResetPasswordForm = ({ handleClose, id, resource }) => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const validatePassword = (value) => {
    if (!value) return "Required";
    if (value.length < 6) return "Password must be at least 6 characters";
    return undefined;
  };

  const validateConfirmPassword = (password) => (value) => {
    if (!value) return "Required";
    if (value.length < 6) return "Password must be at least 6 characters";
    if (value !== password) return "Passwords do not match";
    return undefined;
  };

  return (
    <EditForm
      title="Reset Password"
      handleClose={handleClose}
      id={id}
      resource={resource}
    >
      <Grid item xs={12}>
        <Grid item xs={12}>
          <TextInput
            id="password"
            name="password"
            label="Password"
            type={showPassword ? "text" : "password"}
            fullWidth
            validate={[required(), validatePassword]}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid item xs={12}>
          <TextInput
            id="confirmpassword"
            name="confirmpassword"
            label="Confirm Password"
            type={showConfirmPassword ? "text" : "password"}
            fullWidth
            validate={[required(), validateConfirmPassword(password)]}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    edge="end"
                  >
                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>
    </EditForm>
  );
};

export const ResetPasswordFormDialog = ({ openDialog, handleDialogClose }) => {
  const { handleMenuClose } = React.useContext(DialogueContext);
  const handleClose = () => {
    handleDialogClose();
    handleMenuClose();
  };
  const record = useRecordContext();
  const resource = useResourceContext();

  return (
    <Dialog
      open={openDialog}
      onClose={handleClose}
      onKeyDown={(evt) => evt.stopPropagation()}
    >
      <ResetPasswordForm
        handleClose={handleClose}
        id={record.id}
        resource={resource}
      />
    </Dialog>
  );
};
